import { render } from "./LogoImage.vue?vue&type=template&id=73707e1b"
import script from "./LogoImage.vue?vue&type=script&lang=js"
export * from "./LogoImage.vue?vue&type=script&lang=js"
script.render = render

export default script